<wiz-vgroup width="100%" height="100%" class="section-container" padding="5px">

  <wiz-hgroup width="100%">
    <wiz-label width="100%" [wizLabel]="'$.widget.filters.$'" class="smallTitleLabel"></wiz-label>
  </wiz-hgroup>
  
  <wiz-vgroup width="100%" height="100%" style="overflow: hidden auto !important; padding-top: 5px; padding-bottom: 10px;">
    <ng-container #containerFilter ></ng-container>
  </wiz-vgroup>
   

   <wiz-hgroup width="100%" horizontalAlign="space-between">
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'arrow-left'"
      (wizClick)="doCancel()"
      [wizLabel]="'$.common.cancel.$'"
    ></wiz-button>
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.ok.$'"
      [wizIcon]="'arrow-right'"
      [iconPlacement]="'right'"
      (wizClick)="save()"
    ></wiz-button>
  </wiz-hgroup>
  <!-- fin zone détail -->
</wiz-vgroup>
